import { RISK_PROFILES_LIST_APP_STATE_SLICE_KEY, RISK_PROFILES_LIST_STATE_KEYS } from '../state/constants';
import { AppStateService } from 'NewAngular/services/app-state.service';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/app-state.service";
export class RiskProfilesListAppStateService {
    constructor(ajaxService, appStateService) {
        this.ajaxService = ajaxService;
        this.appStateService = appStateService;
    }
    initAppState() {
        this.appStateService.setStateSlice(RISK_PROFILES_LIST_APP_STATE_SLICE_KEY);
        this.appStateService.setUrlParamKeys(RISK_PROFILES_LIST_STATE_KEYS);
        this.appStateService.start();
    }
    get enabled() {
        return this.appStateService.enabled;
    }
}
RiskProfilesListAppStateService.ɵfac = function RiskProfilesListAppStateService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskProfilesListAppStateService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.AppStateService)); };
RiskProfilesListAppStateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RiskProfilesListAppStateService, factory: RiskProfilesListAppStateService.ɵfac, providedIn: 'root' });
